export default __webpack_public_path__ + "static/media/FINDE_OFFEN_MANUAL.df74ce2d.png";